import React, { Component } from 'react';
//import { connect } from 'react-redux';
//import { bindActionCreators } from 'redux';
//import { actionCreators as navigationStore } from '../../store/Navigation';

import { Switch } from 'react-router-dom';
import AppLayoutRoute from '../Layout/AppLayoutRoute';
import Home from '../Home/Home';
import ActionHandler from '../Actions/ActionHandler';

//import history from '../../utils/History.js';
//import { ApplicationInsights } from '@microsoft/applicationinsights-web';
//import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

// Initialize Application Insights react plugin
//const reactPlugin = new ReactPlugin();
//fetch('/app/publicsettings').then(result => result.json()).then(data => {
//	var appInsights = new ApplicationInsights({
//		config: {
//			instrumentationKey: data.instrumentationKey,
//			extensions: [reactPlugin],
//			extensionConfig: {
//				[reactPlugin.identifier]: { history: history }
//			}
//		}
//	});
//	appInsights.loadAppInsights();
//});


class AuthenticatedApp extends Component {	

	componentDidMount() {
		//this.props.getMenuItems();
	}

	render() {
		return (<Switch>
			<AppLayoutRoute exact path='/' component={Home} pageName="home" logoUrl={ this.props.logoUrl } />
			<AppLayoutRoute path='/action/:id' component={props => <ActionHandler {...props} />} pageName="action" />
		</Switch>);
	}
}

//const mapStateToProps = (state) => {
//	return {		
//		...state.navigation,
//	};
//};

export default AuthenticatedApp;
//export default withAITracking(reactPlugin, AuthenticatedApp);
//export default connect(
//	mapStateToProps,
//	dispatch => bindActionCreators({ ...navigationStore }, dispatch)
//)(AuthenticatedApp);








// WEBPACK FOOTER //
// ./src/components/App/AuthenticatedApp.js